"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageTemplateDto = exports.ChannelCTADto = void 0;
class ChannelCTADto {
}
exports.ChannelCTADto = ChannelCTADto;
class MessageTemplateDto {
}
exports.MessageTemplateDto = MessageTemplateDto;
